import React, { Component } from 'react';
import { arrayOf, shape, string, any, func } from 'prop-types';
import { DESC } from '../../../BaseDataTable';
import { Tooltip } from '@material-ui/core';
import { Info as InfoIcon, ArrowUpward, ArrowDownward } from '@material-ui/icons';
import classNames from 'classnames';
import styles from './styles.scss';

export default class DaypartTableHeader extends Component {
  static propTypes = {
    headers: arrayOf(shape({
      title: string, 
      key: string,
    })),
    headerTooltipText: string,
    adsTooltipText: string,
    iconKey: string,
    sortKey: string,
    sortStatus: shape({any}),
    onCellClick: func
  }

  static defaultProps = {
    headerTooltipText: 'Sort',
    adsTooltipText: 'Recommended 50+ ads for statistical relevance',
    iconKey: 'ads'
  }

  drawArrowIcon() {
    const { sortKey, sortStatus } = this.props;
    const arrowIcon = sortStatus[sortKey] === '' ||
                      sortStatus[sortKey] === DESC ?
                      <ArrowDownward className={styles.arrowIcon}/> :
                      <ArrowUpward className={styles.arrowIcon}/>;
    return <span>{arrowIcon}</span>
  }

  drawTableHeader() {
    const { headers, headerTooltipText, adsTooltipText, iconKey, sortKey, onCellClick } = this.props;
    return headers && headers.map(header => {
      const { title, key } = header;
      const arrowIcon = sortKey === key && this.drawArrowIcon();
      if(title && key) {
        return (
          <div className={styles.tableCell} key={key} onClick={onCellClick(key)}>
            {arrowIcon}
            <div>
              <Tooltip title={headerTooltipText} placement="top-start">
                <span>{header.title}</span>
              </Tooltip>
            {key === iconKey &&
              <Tooltip title={adsTooltipText} placement="top-start">
                <InfoIcon className={styles.infoIcon}/>
              </Tooltip>}
            </div>
          </div>
        )
      }
    })
  }

  render() {
    const tableHeaderCell = this.drawTableHeader();
    return (
      <div className={classNames(styles.tableRow, styles.tableHeader)}>
        {tableHeaderCell}
      </div>
    )
  }
};
